export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/interiorFaulty.ee211ce9.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};